import React from "react";
import Hero from "../../Component/Hero/Hero";
import State from "../../Component/Hero/State";
import WhyMedmyne from "../../Component/Hero/WhyMedmyne";
import AboutMedmine from "../../Component/AboutMedmine/AboutMedmine";
import Team from "../../Component/Hero/Team";
import DoctorReviews from "../../Component/Hero/DoctorReviews";
import HowDoesItWork from "../../Component/HowDoesItWork/HowDoesItWork";
import PatientReview from "../../Component/PatientReview/PatientReview";

const Home = () => {
  return (
    <div>
      <Hero />
      <State />
      <WhyMedmyne />
      <AboutMedmine />
      <Team color={"bg-white"} />
      <DoctorReviews />
      <HowDoesItWork />
      <PatientReview />
    </div>
  );
};

export default Home;
